import React from "react";

import { AlignedRichTextSubBlock as Value } from "@reactivated";

import { injectComponents } from "../../utils/injection";
import { concatClassNames, getStyleVariantClass } from "../../utils/styles";
import { IntrinsicElementProps } from "../../utils/types";
import { RichTextBlock } from "../RichText";

import styles from "./index.module.scss";

type Props = React.PropsWithChildren<{
    /**
     * Streamfield Block value
     */
    value: Value;

    /**
     * Extra attributes to set on the top-level element.
     */
    attrs?: IntrinsicElementProps;
}>;

const dependencies = {
    RichTextBlock,
} as const;

export const AlignedRichTextSubBlock = injectComponents(dependencies)<Props>((
    props,
) => {
    const { RichTextBlock } = props.dependencies;
    const attrs = props.attrs || {};
    attrs.className = concatClassNames([
        attrs.className,
        styles.root,
        getStyleVariantClass(styles, props.value.alignment),
    ]);
    return (
        <section {...attrs}>
            {props.value.content && (
                <RichTextBlock value={props.value.content} />
            )}
            {props.children}
        </section>
    );
});
